import React, { useEffect, useRef } from "react";
import { Layout } from "Components/Layout/Layout";
import Main from "Containers/Dashboard/Main/Main";
import { useLocation, useNavigate } from "react-router";
import { withDashboardDefaults } from "./dashboardDefaults";

export const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    const targetSearch = withDashboardDefaults(location.search);
    if (new URLSearchParams(location.search).toString() !== targetSearch) {
      navigate({ ...location, search: `?${targetSearch}` }, { replace: true });
    }
  }, [location, navigate]);

  return (
    <Layout>
      <Main />
    </Layout>
  );
};
